import { useEffect } from 'react'
import { CAL_NS, CAL_LINK } from '../data/modalModelOptions'

// Loads the Cal.com embed script once, globally — verbatim port of Cal.com's
// standard embed-loader snippet. `window.Cal` becomes a global function.
export function useCalEmbedLoader() {
  useEffect(() => {
    (function (C, A, L) {
      let p = function (a, ar) { a.q.push(ar) }
      let d = C.document
      C.Cal = C.Cal || function () {
        let cal = C.Cal
        let ar = arguments
        if (!cal.loaded) {
          cal.ns = {}
          cal.q = cal.q || []
          d.head.appendChild(d.createElement('script')).src = A
          cal.loaded = true
        }
        if (ar[0] === L) {
          const api = function () { p(api, arguments) }
          const namespace = ar[1]
          api.q = api.q || []
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api
            p(cal.ns[namespace], ar)
            p(cal, ['initNamespace', namespace])
          } else p(cal, ar)
          return
        }
        p(cal, ar)
      }
    })(window, 'https://app.cal.com/embed/embed.js', 'init')
  }, [])
}

let calBooted = false

export function openCalBooking(prefillConfig) {
  if (calBooted) return
  calBooted = true
  window.Cal('init', CAL_NS, { origin: 'https://app.cal.com' })
  window.Cal.ns[CAL_NS]('inline', { elementOrSelector: '#cal-booking', config: prefillConfig, calLink: CAL_LINK })
  window.Cal.ns[CAL_NS]('ui', { hideEventTypeDetails: false, layout: 'month_view' })
}

// The inline embed targets the `#cal-booking` element, which unmounts with the
// modal. Reset the latch when StepDone unmounts so the next reservation
// re-initializes into the fresh element (otherwise the booking panel renders
// empty on every reservation after the first).
export function resetCalBooking() {
  calBooted = false
}

export function openCalModal() {
  window.Cal('init', CAL_NS, { origin: 'https://app.cal.com' })
  window.Cal.ns[CAL_NS]('modal', { calLink: CAL_LINK, config: { layout: 'month_view' } })
}
